import { EmplacementView } from "@features/stock/components/EmplacementView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/emplacements/$id/view")({
  loader: requirePermission(PERMISSIONS.STOCK.EMPLACEMENTS.VIEW),
  component: ViewEmplacementComponent,
});

function ViewEmplacementComponent() {
  const { id } = Route.useParams();

  return <EmplacementView id={Number(id)} />;
}
